import React from 'react'
import { useForm, ValidationError } from '@formspree/react';
import './contact.css'

function Contact() {
    const [state, handleSubmit] = useForm("xrgwjabd");

     return (
        <div>
            <h1 className="heading">Contact <span>me</span></h1>

            <div className="row">
                <div className="content">
                    <h3 className='title'>Contact Info</h3>
                    <div className="info">

                        <div className='email'>

                            <h3 >
                                <i className="fas fa-envelope"></i>
                                raymolide@gmail.com
                            </h3>
                        </div>
                        <h3>
                            <i className="fas fa-phone"></i>
                            (+258) 822570768
                        </h3>
                        <h3>
                            <i className="fas fa-phone"></i>
                            (+258)  848638584 (WhatsApp)
                        </h3>
                        <h3>
                            <i className="fas fa-map-marker-alt"></i>
                            Mozambique, Maputo, Av. Josina Machel.
                        </h3>
                    </div>
                </div>

                

                <form method='POST' action='https://formspree.io/f/xrgwjabd' onSubmit={handleSubmit}>
                    <input type="text" className='box' name='=name' id='name' placeholder='name' />
                    <ValidationError
                        prefix="Name"
                        field="name"
                        errors={state.errors}
                    />
                    <input type="email" className='box' name='email' id='email' placeholder='email' />
                    <ValidationError
                        prefix="Email"
                        field="email"
                        errors={state.errors}
                    />
                    <input type="text" className='box' id='subject' name='subject' placeholder='subject' />
                    <ValidationError
                        prefix="Subject"
                        field="subject"
                        errors={state.errors}
                    />
                    <textarea className='box message' name="message" id="message" cols={30} rows={10} placeholder="Message"></textarea>
                    <ValidationError
                        prefix="Message"
                        field="message"
                        errors={state.errors}
                    />

                    {state.succeeded ? <p className="heading">Sent, Thank you! <span>See you soon.</span></p> :<button type='submit' className='btn' disabled={state.submitting}>Send <i className="fas fa-paper-plane"></i></button>}
                    
                </form>
            </div>
        </div>
    )
}

export default Contact